module.exports = __webpack_public_path__ + "img/Rectangle.42b1730d.png";